module.exports = __webpack_public_path__ + "static/img/1.d09d78b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/2/1.png
// module id = eTwD
// module chunks = 0